module.exports = __webpack_public_path__ + "img/3.fa0388d9.png";